function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 200 200",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#23fbcd",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#3184af",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "translate(10 10)",
    d: "M90 0c49.68 0 90 40.32 90 90s-40.32 90-90 90S0 139.68 0 90 40.32 0 90 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "translate(25 40.01)",
    d: "m65.37 119.865-14.295-4.148c-1.5-.421-2.343-1.992-1.922-3.492L81.143 2.03c.421-1.5 1.992-2.343 3.492-1.922L98.93 4.256c1.5.421 2.343 1.992 1.921 3.492L68.862 117.943c-.445 1.5-1.992 2.367-3.492 1.922zM38.652 93.57l10.194-10.875a2.811 2.811 0 0 0-.188-4.03L27.426 59.986l21.232-18.678c1.196-1.055 1.289-2.883.188-4.03L38.652 26.402a2.815 2.815 0 0 0-3.984-.117L.897 57.924a2.793 2.793 0 0 0 0 4.101l33.77 31.662c1.148 1.078 2.93 1.032 3.985-.117zm76.68.14 33.771-31.66a2.793 2.793 0 0 0 0-4.102l-33.77-31.684a2.838 2.838 0 0 0-3.985.117l-10.194 10.875a2.811 2.811 0 0 0 .188 4.03l21.232 18.702-21.232 18.678c-1.196 1.054-1.289 2.883-.188 4.03l10.194 10.875c1.055 1.15 2.835 1.196 3.984.141z"
  }));
};

export default SvgLogo;